<!--
 * @description: banner
 * @Author: wxy
 * @Date: 2020-02-11 13:50:23
 -->
<template>
  <div class="banner">
    <div class="text-container">
      <span class="text1">随时随地 移动办公</span>
      <span class="text2">效率 + 规范 + 沟通</span>
      <span class="register" @click="registerCli">立即注册</span>
    </div>
    <img src="@/assets/img/dashboard/banner.png" />
  </div>
</template>

<script>
export default {
  methods: {
    registerCli() {
      window.open('https://teamlink.unicloud.com/tenant-mss/#/register', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 1000px;
  margin: 0 auto;
  color: #fff;
  padding: 30px 0;
  overflow: hidden;
  img {
    width: 615px;
    float: right;
  }
  .text-container {
    padding-top: 80px;
    float: left;
    .text1,
    .text2 {
      display: block;
    }
    .text1 {
      font-size: 34px;
      margin-bottom: 30px;
    }
    .text2 {
      font-size: 16px;
      margin-bottom: 40px;
    }
    .register {
      display: inline-block;
      color: #0970d6;
      font-size: 20px;
      border-radius: 3px;
      cursor: pointer;
      background: #fff;
      width: 135px;
      height: 50px;
      line-height: 50px;
      text-align: center;
    }
  }
}
@media (max-width: 770px) {
  .banner  {
    width: 90%;
    padding-top: 36px;
    img {
      display: none;
    }
    .banner-logo {
      display: block;
      .logo {
        float: none;
        display: block;
        margin: 0 auto;
        width: 70px;
        height: 70px;
      }
      .title {
        font-size: 20px;
        margin-top: 10px;
        text-align: center;
      }
    }
    .text-container {
      width: 100%;
      float: none;
      padding: 16px 0 25px 0;
      font-size: 0;
      text-align: center;
      .text1 {
        font-size: 24px;
        margin-bottom: 20px;
      }
      .text2 {
        font-size: 16px;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
